import Util from '../../../../../forecast-app/shared/util/util';
import {createToast} from '../../../../../forecast-app/shared/components/toasts/another-toast/toaster';

export const createProjectUpdateToast = intl => {
	createToast({
		duration: 60000,
		message: intl.formatMessage({id: 'project_budget.project_update_toast'}),
		isDisplayingDuration: true,
		callback: () => {
			location.reload();
		},
	});
};

export const filterAggregateFields = (project, fields) => {
	return fields
		.filter(field => project.billable || !(field.includes('Revenue') || field.includes('Profit')))
		.filter(field => !Util.hasLimitedFinancialAccess() || !(field.includes('Cost') || field.includes('Profit')));
};

export const getCurrency = (company, project) => {
	return project.rateCard && project.rateCard.currency ? project.rateCard.currency : company.currency;
};

export const renderCurrency = (currencySymbol, value, intl) => {
	if (value) {
		return Util.getFormattedNumberWithCurrency(currencySymbol, value, intl);
	} else {
		return '–';
	}
};

export const renderMinutes = (minutes, intl) => {
	if (minutes) {
		return Util.convertMinutesToFullHour(minutes, intl);
	} else {
		return '–';
	}
};

export const renderPercentage = (percentage, intl) => {
	if (percentage) {
		return Util.getFormattedPercentage(percentage, intl);
	} else {
		return '–';
	}
};

export const getTotalsParams = aggregates => {
	const result = {
		baselineRevenue: false,
		baselineCost: false,
		baselineProfit: false,
		actualRevenue: false,
		actualCost: false,
		actualProfit: false,
		plannedRevenue: false,
		plannedCost: false,
		plannedProfit: false,
		remainingRevenue: false,
		remainingCost: false,
		remainingProfit: false,
		forecastRevenue: false,
		forecastCost: false,
		forecastProfit: false,
		actualVsPlanRevenue: false,
		actualVsPlanCost: false,
		actualVsPlanProfit: false,
		forecastVsPlanRevenue: false,
		forecastVsPlanCost: false,
		forecastVsPlanProfit: false,
		baselineVsActualRevenue: false,
		baselineVsActualCost: false,
		baselineVsActualProfit: false,
		baselineVsForecastRevenue: false,
		baselineVsForecastCost: false,
		baselineVsForecastProfit: false,
		invoiced: false,
		paid: false,
		baselineMinutes: false,
		baselineVsRegisteredMinutes: false,
		baselineVsForecastMinutes: false,
		registeredMinutes: false,
		scopeApprovedMinutes: false,
		registeredVsScopeApprovedMinutes: false,
		remainingMinutes: false,
		forecastMinutes: false,
		forecastVsScopeApprovedMinutes: false,
	};

	for (let i = 0; i < aggregates.length; i++) {
		result[aggregates[i]] = true;
	}

	return result;
};
